import { render } from "./Card.vue?vue&type=template&id=8a413080"
import script from "./Card.vue?vue&type=script&lang=ts"
export * from "./Card.vue?vue&type=script&lang=ts"

import "./Card.vue?vue&type=style&index=0&id=8a413080&lang=scss"
script.render = render

export default script